import * as React from 'react'
import WidgetGrid from '../widget-grid/widget-grid.component'
import WidgetCodeBlock from '../widget-codeblock/widget-codeblock.component'
import WidgetContent from '../widget-content/widget-content.component'
import WidgetHeader from '../widget-header/widget-header.component'
import WidgetKeyValue from '../widget-key-value/widget-key-value.component'
import WidgetTile from '../widget-tile/widget-tile.component'

type TNode =
  | GatsbyTypes.codeBlockFragment
  | GatsbyTypes.contentFragment
  | GatsbyTypes.gridFragment
  | GatsbyTypes.gridLevel1Fragment
  | GatsbyTypes.gridLeafFragment
  | GatsbyTypes.headingFragment
  | GatsbyTypes.keyValueFragment
  | GatsbyTypes.tileFragment

export type WidgetResolverProps = {
  node?: GatsbyTypes.Maybe<TNode>
}

const WidgetResolver: React.FC<WidgetResolverProps> = ({ node }) => {
  if (!node) return null
  switch (node.__typename) {
    case 'ContentfulGrid':
      return (
        <WidgetGrid grid={node}>{node?.gridItems?.map(item => (item ? <WidgetResolver key={item.id} node={item} /> : null))}</WidgetGrid>
      )
    case 'ContentfulCodeBlock':
      return <WidgetCodeBlock codeBlock={node} />
    case 'ContentfulContent':
      return <WidgetContent contents={node} />
    case 'ContentfulHeading':
      return <WidgetHeader header={node} />
    case 'ContentfulKeyValue':
      return <WidgetKeyValue keyValue={node} />
    case 'ContentfulTile':
      return <WidgetTile tile={node} />
    default:
      return null
  }
}

export type WidgetResolverMultiProps = {
  nodes?: GatsbyTypes.Maybe<readonly GatsbyTypes.Maybe<TNode>[]>
}

export const WidgetResolverMulti: React.FC<WidgetResolverMultiProps> = ({ nodes }) => {
  if (!nodes) return null
  return <>{nodes.map(node => (node ? <WidgetResolver key={node.id} node={node} /> : null))}</>
}

export const WidgetResolverMultiMemoized = React.memo(WidgetResolverMulti)

export default WidgetResolver
